export default ({ label, heading, url }) => ({ label, heading, url });
